module.exports = __webpack_public_path__ + "templates/sellerCashierSearch.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/core/components/sellerCashierSearch/sellerCashierSearch.html
// module id = 283
// module chunks = 15